import { ChevronRight } from "react-bootstrap-icons";
import * as Styled from "./TemplateCard.styled";
import DragRows from "../../../assets/images/icons/icon-drag-rows.svg";
import { Switch, TemplateCardProps } from "../../../libs";
import React from "react";

export const TemplateCard: React.FC<TemplateCardProps> = ({
    title,
    subtitle,
    svgSrc,
    onClick,
    showChevron = true,
    showDragIcon = false,
    compact = false,
    showToggle = false,
    toggleValue = false,
    onToggle
}) => {
    return (
        <Styled.StyledCard onClick={onClick} compact={compact}>
            {/* Drag icon shown in center before the text */}
            {showDragIcon && (
                <Styled.CenteredIcon>
                    <img src={DragRows} alt="Drag Rows" />
                </Styled.CenteredIcon>
            )}

            {/* Main SVG display */}
            {svgSrc ? (
                <Styled.SvgImage src={svgSrc} alt={title} />
            ) : (
                <Styled.SvgPlaceholder />
            )}


            {/* Card Text */}
            <Styled.CardText>
                <Styled.Title>{title}</Styled.Title>
                <Styled.Subtitle>{subtitle}</Styled.Subtitle>
            </Styled.CardText>

            {/* Chevron Button (optional) */}
            {showChevron && (
                <Styled.Circle>
                    <ChevronRight />
                </Styled.Circle>
            )}

            {/* Toggle Switch (optional) */}
            {showToggle && (
                <Switch
                    checked={toggleValue}
                    onChange={(e) => onToggle && onToggle(e.target.checked)}
                />
            )}


        </Styled.StyledCard>
    );
}
